import React, { useState, useEffect } from "react";
import { Avatar_02 } from "../../Routes/ImagePath";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import EssFullWidthModal from "components/modelpopup/baseModal"
import { Button } from "components/Button";
import { Controller } from "react-hook-form";
import {  useSelector } from 'react-redux';
import FilterSelect from "components/Form/filterSelect";
import { createLeavePlanner, updateLeavePlanner } from "api/services/leave";
import {  toast, Bounce } from 'react-toastify';
import { getLeaveType } from "api/services/common";
import { customStyleSelect } from "utils/common";
import {format} from "date-fns"
const LeavePlannerModal = ({
    leavePlannerModal,
    setLeavePlannerModal,
    selectedLeavePlanner,
    fetchLeavePlanner,
    setSelectedLeavePlanner,
    user

}) => {
 
  const [loading, setLoading]=  useState(false);

  const [leaveTypes, setLeaveTypes]=  useState(false);


  useEffect(()=>{
    if(leavePlannerModal && selectedLeavePlanner?.id){
      setValue("start_date", selectedLeavePlanner?.start_date)
      setValue("end_date", selectedLeavePlanner?.end_date)
  
   
      setValue("leave_type", leaveTypes.find(item=> item.value==selectedLeavePlanner?.leave_planner?.leave_type?.id ))
  
    }
    
  
  }, [leavePlannerModal, selectedLeavePlanner, leaveTypes])

  useEffect(()=>{
    getLeaveType().then(res=>{
      
      setLeaveTypes(
        res.data.results
          .filter(item => ["PATERNITY LEAVE", "SYSMAT", "SYSANNUAL"].includes(item.code))
          .map(item => ({
            label: item.description,
            value: item.id
          }))
      );
    })
  },[])




  const schema = yup.object().shape({
    leave_type: yup.object().required("Leave type is required"),
    start_date: yup.date().required("Start date is required"),
    end_date: yup
      .date()
      .required("End date is required")
      .min(yup.ref("start_date"), "End date cannot be before start date"),
  });
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    setError,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      leave_type: "",
      start_date: "",
      end_date: "",
    },
  });



  const startDate = watch("start_date");
  const endDate = watch("end_date");

  useEffect(() => {
    if (startDate && !endDate) {
      setValue("end_date", startDate);
    }
  }, [startDate, endDate, setValue]);



const handleReset = () => {

  reset();
  setLoading(false)
  setSelectedLeavePlanner("")

};

  const onSubmit = async (data) => {
    console.log(data)
    let payload = {
      ...data,
   
    }

    payload["start_date"] = format(new Date(payload?.start_date), "yyyy-MM-dd");
    payload["end_date"] = format(new Date(payload?.end_date), "yyyy-MM-dd");
    payload["leave_type"] = payload?.leave_type?.value
    payload["company_user"] = user?.id

    if(selectedLeavePlanner?.id){
      updateLeavePlan(payload)
    }else{
      
        createLeavePlan(payload)
    }
 

  };
  const updateLeavePlan = (payload) => {
    setLoading(true)
    updateLeavePlanner(selectedLeavePlanner?.leave_planner?.id,payload).then(response=>{

      setLeavePlannerModal(false)
      setLoading(false)
      handleReset()
      toast.success('Leave Plan updated!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        fetchLeavePlanner()
    }).catch(e=>{
      try{
        console.log(e.response.data, "EEEEE")
        // let response = e.response?.data?.error || "Error updating leave status!"
        setLoading(false)
    

      if(e.response.data){
        Object.entries(e.response.data).forEach(([k, v]) => {
          console.log(typeof v,k, "EEEEE")
          setError(k,
            {
              type: 'manual',
              message: v.join(", ")
            }
             )
        })
      }
      }catch(err){
        console.log(err, "LLLLLLL")
        let response = e.response?.data?.error || "Error updating leave plan!"
        setLoading(false)
          toast.error(response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        
      }

    })
  }
 
  const createLeavePlan = (payload) => {
    setLoading(true)
    createLeavePlanner(payload).then(response=>{

      setLeavePlannerModal(false)
      setLoading(false)
      handleReset()
      toast.success('Leave plan added!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        fetchLeavePlanner()
    }).catch(e=>{
      try{
        console.log(e.response.data, "EEEEE")
        // let response = e.response?.data?.error || "Error updating leave status!"
        setLoading(false)
    

      if(e.response.data){
        Object.entries(e.response.data).forEach(([k, v]) => {
          console.log(typeof v,k, "EEEEE")
          setError(k,
            {
              type: 'manual',
              message: v.join(", ")
            }
             )
        })
      }
      }catch(err){
        console.log(err, "LLLLLLL")
        let response = e.response?.data?.error || "Error creating leave plan!"
        setLoading(false)
          toast.error(response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        
      }

    })
  }
 

  return (
    <>
      <EssFullWidthModal
        mask={false}
        title={selectedLeavePlanner ? "Update Leave Plan" : "Add Leave Plan"}
        // style={{ top: 100 }}
        open={leavePlannerModal}
        width={"40%"}
        footer={[]}
        onCancel={() => {
            setLeavePlannerModal(false)
            handleReset()
        
        }}
        className="full-width-modal"
     >
        <div className="modal-content">
            
            <div className="modal-body">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row" >
                {
            selectedLeavePlanner?.id &&
            <div className="mb-3 col-md-6 col-sm-12">
            <label className="form-label">User</label>
           <input className="form-control "  readOnly value={`${selectedLeavePlanner?.leave_planner?.company_user?.first_name} ${selectedLeavePlanner?.leave_planner?.company_user?.last_name}` } />
          </div>
          }
                <div className="mb-3 col-md-6 col-sm-12">
            <label className="form-label">Leave Type</label>
            <Controller
                        name={`leave_type`}
                        // name={"assignee"}
                        control={control}
                        // defaultValue=""
                        // rules={{ required: 'Select a contact' }}
                        render={({ field }) => (
                          <>
                            <FilterSelect 
                            isClearable={true} 
                            isDisabled={selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id }
                            onChange={(e) => {
                              field.onChange(e);
                            }}
                            optionLabel={"label"} 
                            optionValue={'value'} 
                            options={leaveTypes}
                            value={field.value}
                              placeholder={"Leave Type"}
                              styles={customStyleSelect}
                              isLoading={false}
                              />

                           
                          </>
                        )}
                      />
            {errors.leave_type && <div className="text-danger">{errors.leave_type.message}</div>}
          </div>


        
                     </div>
          
          <div className="row" >
          <div className="mb-3 col-md-6 col-sm-12">
            <label className="form-label">Start Date</label>
            <input type="date" className="form-control" {...register("start_date")} 
            disabled={selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id }
            />
            {errors.start_date && <div className="text-danger">{errors.start_date.message}</div>}
          </div>

          <div className="mb-3  col-md-6  col-sm-12">
            <label className="form-label">End Date</label>
            <input type="date" className="form-control" {...register("end_date")}
             disabled={selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id }/>
            {errors.end_date && <div className="text-danger">{errors.end_date.message}</div>}
          </div>
             </div>

 

           {/* 🔹 Submit Button */}
           <div className="submit-section">
                  <Button
                    loading={loading}
                    disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                    className="btn btn-primary submit-btn"
                    type="submit"
                    label="Submit"
                  />
                </div>
        </form>
        
            </div>
          </div>
     </EssFullWidthModal>

    

    </>
  );
};

export default LeavePlannerModal;
